import styled from 'styled-components';

export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f7f7f7;
  color: ${({ theme }) => theme.colors.text.primary};
  height: 100vh;
  overflow: hidden;
`;
